// extracted by mini-css-extract-plugin
export default {"container":"L1-z","heading":"M1-z","links":"N1-z","copy":"O1-z","subCopy":"P1-z","linksLeft":"Q1-z","linksCenter":"R1-z","linksRight":"S1-z","link":"T1-z","onlyLink":"U1-z"};